let _ = require("ES/lib/lodash");

module.exports = function(username){
	let s = _.isString(username) ? username.replace(/\s+/g, "").toUpperCase() : "";
	return s.length > 0 ? s : null;
};



// WEBPACK FOOTER //
// ./src/utils/normalizeUsername.js